const cardOne = {
  title: (
    <>
      We save,
      <br />
      not sting
    </>
  ),
  subtitle: 'Loan options with no fees, no loyalty tax and a rate you can drop.',
  /* Image for the carousel */
  backgroundImage: 'url(/next-assets/carousel/cvp-interestsaving-lg.png)',
  /* Images passed to modals */
  image: {
    desktop: '/next-assets/carousel/cvp-interestsaving-modal-lg.png',
    mobile: '/next-assets/carousel/cvp-interestsaving-modal-sm.png',
  },
  modalContent: [
    {
      heading: 'Drop your own rate',
      paragraph: (
        <>
          With AcceleRATES, we&apos;ll drop your rate as you pay down your Straight Up or Power Up home loan
          <sup>2</sup>.
        </>
      ),
    },
    {
      heading: 'Loyalty is royalty',
      paragraph: (
        <>
          We always give existing and new customers the same awesome rates for like-for-like
          <sup>3</sup> loans with our Automatic Rate Match.
        </>
      ),
    },
    {
      heading: 'No Athena fees',
      paragraph: (
        <>
          Our Straight Up and Power Up loans have zero Athena fees
          <sup>1</sup>!
        </>
      ),
    },
  ],
};

const cardTwo = {
  title: 'Unlock more equity fast',
  subtitle: "We'll help you max your borrowing power.",
  /* Image for the carousel */
  backgroundImage: 'url(/next-assets/carousel/cvp-padlock-lg.png)',
  /* Images passed to modals */
  image: {
    desktop: '/next-assets/carousel/cvp-padlock-modal-lg.png',
    mobile: '/next-assets/carousel/cvp-padlock-modal-sm.png',
  },
  modalContent: [
    {
      heading: 'More power to you',
      paragraph: <>Borrower friendly policies so you can borrow more, fast.</>,
    },
    {
      heading: 'Leverage your equity',
      paragraph: <>Put the extra $$$ towards renos or another property.</>,
    },
    {
      heading: 'Calculate fast',
      paragraph: <>See what you can borrow in 3 minutes.</>,
    },
  ],
};

const cardThree = {
  title: 'Loan structures for max returns',
  subtitle: 'With multi-offsets and splits.',
  /* Image for the carousel */
  backgroundImage: 'url(/next-assets/carousel/cvp-app-lg.png)',
  /* Images passed to modals */
  image: {
    desktop: '/next-assets/carousel/cvp-app-modal-lg.png',
    mobile: '/next-assets/carousel/cvp-app-modal-sm.png',
  },
  modalContent: [
    {
      heading: 'Multi-splits',
      paragraph: (
        <>
          Split up to 10 loans against your property to optimise your loan structure and maximise your tax deductions.
        </>
      ),
    },
    {
      heading: 'Multi-offsets = multi benefits',
      paragraph: <>Stash your cash any way you want, create up to 10 offset sub-accounts.</>,
    },
    {
      heading: 'Cash-out in a snap',
      paragraph: <>Access equity and cash-out easily and quickly through our fast assessment process.</>,
    },
    {
      heading: 'Fee-free variations',
      paragraph: (
        <>
          Makes changes to your loan to suit your investment strategy. All changes to your Straight Up or Power Up loan
          are fee-free.
        </>
      ),
    },
  ],
};
const cardFour = {
  title: 'We find a loan for every home',
  subtitle: 'From simple borrowing scenarios to the really tricky ones.',
  /* Image for the carousel */
  backgroundImage: 'url(/next-assets/carousel/cvp-search-lg.png)',
  /* Images passed to modals */
  image: {
    desktop: '/next-assets/carousel/cvp-search-modal-lg.png',
    mobile: '/next-assets/carousel/cvp-search-modal-sm.png',
  },
  modalContent: [
    {
      heading: 'Loans to suit every borrower and situation',
      paragraph: <>Interest only, fixed, split, fee-free, feature-rich, owner occupier and investor. Take your pick.</>,
    },
    {
      heading: "If we can't give you a loan, we will find a lender who can",
      paragraph: (
        <>
          We want you to get a good home loan, whether it&apos;s with us or one of our valued lending partners. Why?
          Because we actually care.
        </>
      ),
    },
  ],
};

export const carouselCardContent = [cardOne, cardTwo, cardThree, cardFour];
